import { useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';

const useCounter = (initialValue = 0) => {
  const [counter, setCounter] = useState(initialValue);

  const handleIncrease = () => setCounter((prev) => prev + 1);
  const handleDecrease = () => setCounter((prev) => prev - 1);
  const handleReset = () => setCounter(initialValue);
  const handleSetValue = (value) => setCounter(parseInt(value));

  return [
    counter,
    {
      setIncrease: handleIncrease,
      setDecrease: handleDecrease,
      setReset: handleReset,
      setValue: handleSetValue
    }
  ];
};

function CustomHook() {
  const [count, { setIncrease, setDecrease, setReset, setValue }] = useCounter(
    0
  );

  //Randomize Background Color
  //randomize background color
  const [hex, setHex] = useState('#5f5f5');
  const randomizeHex = () => {
    const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
    setHex(randomColor);
  };

  return (
    <section
      className="backgroundColor"
      style={{
        backgroundColor: hex
      }}
    >
      <Helmet>
        <title>Counter App with Custom Hook</title>
        <meta
          name="description"
          content="Counter app created with a custom hook, has increase, reduce, reset, and set value functions"
        />
        <link rel="canonical" href="/custom-hooks" />
      </Helmet>
      <nav className="navigation">
        <ul className="nav-ul">
          <li>
            <Link className="nav-link" to="/">
              Home
            </Link>
          </li>
          <li>
            {' '}
            <Link className="nav-link" to="/useReducerComponent">
              Use Reducer
            </Link>
          </li>
          <li>
            <Link className="nav-link" to="/custom-hooks">
              Custom Hooks
            </Link>
          </li>
          <li>
            {' '}
            <Link className="nav-link" to="/TestError">
              Test Error
            </Link>
          </li>
        </ul>
      </nav>
      <div className="app">
        <div>
          <center className="header">
            <h1>Custom Hook Counter</h1>
          </center>
          <div className="count">
            <h2>Count is: {count}</h2>
          </div>
          <center>
            <input
              placeholder="Set Value"
              className="setValue"
              type="number"
              onChange={(e) => {
                setValue(e.target.value);
              }}
            />
          </center>
          <div className="buttons">
            <button
              onClick={() => {
                setIncrease();
                randomizeHex();
              }}
            >
              +
            </button>

            <button
              onClick={() => {
                setDecrease();
                randomizeHex();
              }}
            >
              -
            </button>
            <button
              onClick={() => {
                setReset();
                randomizeHex();
              }}
              style={{ fontWeight: 900, fontSize: 20 }}
            >
              Reset
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}

export default CustomHook;
